/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


document.addEventListener("DOMContentLoaded", function() {

  document.addEventListener('change', function(e){
    var el = e.target;

    if(el.classList.contains('main_check')) {

      var lineItemsCheckbox = el.closest('table').querySelectorAll('.line-item--check');
      if(el.checked) {
        lineItemsCheckbox.forEach(function(checkbox) {
          checkbox.checked = true;
        });
      } else {
        lineItemsCheckbox.forEach(function(checkbox) {
         checkbox.checked = false;
        });
      }
    }
  });
  
  document.addEventListener('click', function(e){
  	var el = e.target;
   
    
    if(el.classList.contains('removeSelectedItems') || el.closest('.removeSelectedItems')) {
      if(!el.classList.contains('removeSelectedItems')) {
      	el = el.closest('.removeSelectedItems');
      }
       e.preventDefault();
      
      var lineItemsCheckbox = el.closest('.cart-wrapper').querySelectorAll('.line-item--check');
      if(lineItemsCheckbox.length) {

        var itemsArray = [];
        var qty = 0;
        var data = { updates: {} };

        lineItemsCheckbox.forEach(function(checkbox) {
          if(checkbox.checked == true) {
          	var lineItemId = checkbox.getAttribute('data-variant-id');
            itemsArray.push(lineItemId);
          }
        });
        
        
                
        var moveAlong = function() {
          if(itemsArray.length){ 
            // If we still have requests in the queue, let's process the next one.
            var request = itemsArray.shift();
            var data = 'id='+ request + '&quantity=0';
			jQuery.ajax({
              type: 'POST',
              url: '/cart/change.js',
              dataType: 'json',
              data: data,
              success: function(res){
                debugger;
                moveAlong();
              },
              error: function(){
                // if it's not last one Move Along else update the cart number with the current quantity
                if (itemsArray.length){
                  moveAlong()
                } else {
                  location.reload();
                }
              }
            });
          }else{
            location.reload();
          }

        };
        if(itemsArray.length){ 
          moveAlong();
        }
      }
    }
  });

});

